import type {paths} from '../../openapi/auth.swagger';
import {axiosInstance} from '../axiosInstance';

type MarkNotificationsOperation = paths['/executor_web/notifications/mass_update']['patch'];

export type MarkNotificationsReadRequest = NonNullable<
	MarkNotificationsOperation['requestBody']
>['content']['application/json'];

/** PATCH `/executor_web/notifications/mass_update` — отметить уведомления прочитанными */
export function markNotificationsRead(request: MarkNotificationsReadRequest) {
	return axiosInstance.patch('notifications/mass_update', request);
}
